
import { defineComponent } from 'vue'
import ModalDialog from './ModalDialog.vue'
import PrimaryButton from '../buttons/PrimaryButton.vue'
import Loader from '../Loader.vue'
import { DeleteIcon } from '@/components/icons'
import { AlertType } from '@/enums'

export default defineComponent({
  name: 'DeleteOrderModalDialog',

  emits: ['close'],

  components: {
    ModalDialog, PrimaryButton, Loader, DeleteIcon
  },

  props: {
    orderId: { type: String, required: true }
  },

  data: function () {
    return {
      loading: false
    }
  },

  methods: {
    onDelete: async function () {
      this.loading = true

      try {
        const result = await this.$store.dispatch(
          'orders/updateOrder',
          {
            id: this.orderId,
            isArchived: true
          }
        )

        this.loading = false
        if (!result) {
          await this.$store.dispatch('alerts/create', {
            message: 'archiviazione cantiere fallita',
            type: AlertType.error
          })
          return
        }

        await this.$store.dispatch('alerts/create', {
          message: 'archiviazione cantiere riuscita',
          type: AlertType.success
        })
        setTimeout(() => {
          // Then we reload the users
          this.$store.dispatch('orders/reloadOrders')
          this.loading = false
          this.$router.replace({ name: 'Orders' })
        }, 6000)
      } catch (error) {
        console.error('error updating the working site', error)
        this.loading = false
        await this.$store.dispatch('alerts/create', {
          message: 'archiviazione cantiere fallita',
          type: AlertType.error
        })
      }
      this.$emit('close')
    }
  }
})
